import { render, staticRenderFns } from "./ProductPageApp.vue?vue&type=template&id=4618d6c2&scoped=true&"
import script from "./ProductPageApp.vue?vue&type=script&lang=js&"
export * from "./ProductPageApp.vue?vue&type=script&lang=js&"
import style0 from "./ProductPageApp.vue?vue&type=style&index=0&id=4618d6c2&scoped=true&lang=css&"
import style1 from "./ProductPageApp.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4618d6c2",
  null
  
)

export default component.exports